/*
https://vuex.vuejs.org/guide/
https://markus.oberlehner.net/blog/combining-graphql-and-vuex/
https://github.com/vuejs/vuex/tree/dev/examples
*/

import Vue from "vue";
import Vuex from "vuex";
import session from "./session.js";
import questLeaderboard from "./questLeaderboard.js";
import playerProfile from "./playerProfile.js";
import world from "./world.js";
import playerLeaderboard from "./playerLeaderboard.js";
import rideDetails from "./rideDetails.js";

import admin from "./admin/admin.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoading: false,
  },
  mutations: {
    setIsLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
  },
  modules: {
    session: session,
    questLeaderboard: questLeaderboard,
    playerProfile: playerProfile,
    world: world,
    playerLeaderboard: playerLeaderboard,
    rideDetails: rideDetails,
    admin: admin,
  },
});
